<script lang="ts">
	export let klass = ''
</script>

<div class=" flex justify-center items-center {klass}">
  <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
</div>